import { Reducer, ReducerCreatorCallback } from 'utils/reducer/reducerTypes';

export const createReducer = <StateType, EventType>(
  reducer: Reducer<StateType, EventType>,
  callback?: ReducerCreatorCallback<StateType, EventType>
): Reducer<StateType, EventType> => (prevState, event) => {
  const nextState = reducer(prevState, event);

  if (callback) {
    callback({ prevState, nextState }, event);
  }

  return nextState;
};
